import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';

import './pricing.css';

import {
    BrowserRouter as Router,
    Route,
    Link,
    NavLink,
    Redirect,
    withRouter,

} from 'react-router-dom'

import {
    CSSTransition,
    TransitionGroup,
} from 'react-transition-group';


const styles = theme => ({
    listItem: {
        padding: `${theme.spacing.unit}px 0`,
    },
    total: {
        fontWeight: '700',
    },
    title: {
        marginTop: theme.spacing.unit * 2,
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    textFieldLabel: {
        // color: "red",
        textAlign: "left",
        fontFamily: [
            'Open Sans',
            'sans-serif'

        ].join(','),
    },
    textField: {
        // marginLeft: theme.spacing.unit,
        // marginRight: theme.spacing.unit,
        // // width: 50,

        color: "#203b60",
        textAlign: "left",

        fontFamily: [
            'Open Sans',
            'sans-serif'

        ].join(','),
    },
    MtextField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        // width: 50,

        color: "#203b60",
        fontSize: "18px",
        textAlign: "left",

        fontFamily: [
            'Open Sans',
            'sans-serif'

        ].join(','),
    },
    dense: {
        marginTop: 19,
    },
    menu: {
        width: 200,
    },
    paper: {
        // marginTop: theme.spacing.unit * 3,
        textAlign: 'center',
        width: '100%',
        height: '100%',
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit,
        paddingBottom: '0px',
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            // marginTop: theme.spacing.unit * 6,
            marginBottom: theme.spacing.unit * 3,
            padding: theme.spacing.unit * 2,
            paddingBottom: '0px',
        },
    },
    layout: {
        width: 'auto',
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
            // width: '1000px',
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    button: {
        // margin: theme.spacing.unit,
        // boxShadow: 'none',
        textTransform: 'none',
        fontSize: 16,
        // fontWeight:'800',
        padding: '3px 6px',
        border: '1px solid',
        color: 'white',
        width: '100%',
        // lineHeight: 1.5,
        backgroundColor: 'rgb(37,106,167)',
        borderColor: 'rgb(37,106,167)',
        fontFamily: [
            'Open Sans',
            'sans-serif'

        ].join(','),
        '&:hover': {
            backgroundColor: '#203b60',
            borderColor: '#203b60',
        },
        '&:active': {
            boxShadow: 'none',
            backgroundColor: '#0062cc',
            borderColor: '#005cbf',
        },
    },

    buttonBack: {

        textTransform: 'none',
        fontSize: 16,
        padding: '3px 6px',
        color: '#203b60',
        width: '100%',
        backgroundColor: '#f2f2f2',
        fontFamily: [
            'Open Sans',
            'sans-serif'

        ].join(','),

    },
    commonMargin: {
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit
    }



});

class DemoRequest extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }

        this.goBack = this.goBack.bind(this)

    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }



    goBack() {
        this.props.history.push({
            pathname: '/choose_service'
        })
    }


    render() {
        const { classes } = this.props;
        return (

            <React.Fragment>
                <CssBaseline />

                <CSSTransition
                    //  key={item.id}
                    in
                    appear
                    timeout={600}
                    classNames="fade500"
                >
                    <main style={{ marginTop: '100px', paddingTop: "10px" }} className={classes.layout}>


                        {/* <h3 style={{ textAlign: 'center', marginBottom: "30px" }}>¿Que tipo de Implementación desea?</h3> */}




                        <Grid container spacing={40} justify="center" style={{ marginBottom: "20px" }}>

                            <Grid item xs={12} sm={6}>
                            <div className="pricing-title">Reservar Demostración</div>
                            <div style={{ color: "rgba(0, 0, 0, 0.54)", fontSize:'14px' }}>
                                            <p><strong>Programe sin cargo su reunión con uno de nuestros consultores, usted obtendrá:</strong></p>
                                            <ul>
                                                <li>Una demostración Online de las aplicaciones que desee.</li>
                                                <li>Acceso exclusivo a una instancia de pruebas sin costo por 30 días.</li>
                                                <li>Asistencia durante su período de prueba a través de nuestro canal de soporte.</li>
                                            </ul>
                                        </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>

                                
                                <Paper className={classes.paper}>
                                    {/* <div className="pricing-title"> Resumen de Servicios</div> */}
                                    {/* <div className="table-responsive"> */}
                                    {/* <img className="img-fuid pb-3" width="150"
                    height="auto" src="/img/implementacion-sitio.png"></img> */}

                                    <Grid style={{ textAlign: 'left' }} item xs={12}>
                                      
                                    </Grid>
                                    {/* <Grid style={{ textAlign: 'left', marginTop:'5px' }} item xs={12}>

                                        
                                    </Grid> */}



                                    <form>
                                        <Grid container spacing={24}>

                                            <Grid item xs={12} >
                                                <TextField
                                                    required
                                                    id="name"
                                                    name="name"
                                                    label="Nombre"
                                                    fullWidth
                                                    // autoComplete="fname"
                                                    value={this.state.company}
                                                    onChange={this.handleTextField}
                                                    InputProps={{
                                                        classes: {
                                                            root: classes.textField,
                                                            input: { textAlign: 'left' }
                                                        },
                                                    }}
                                                    InputLabelProps={{
                                                        classes: {
                                                            root: classes.textFieldLabel,
                                                        },
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={6} >
                                                <TextField
                                                    required
                                                    id="company"
                                                    name="company"
                                                    label="Empresa"
                                                    fullWidth
                                                    // autoComplete="fname"
                                                    value={this.state.company}
                                                    onChange={this.handleTextField}
                                                    InputProps={{
                                                        classes: {
                                                            root: classes.textField,
                                                            input: { textAlign: 'left' }
                                                        },
                                                    }}
                                                    InputLabelProps={{
                                                        classes: {
                                                            root: classes.textFieldLabel,
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} >
                                                <TextField
                                                    required
                                                    id="country"
                                                    name="country"
                                                    label="País"
                                                    fullWidth
                                                    // autoComplete="fname"
                                                    value={this.state.country}
                                                    onChange={this.handleTextField}
                                                    InputProps={{
                                                        classes: {
                                                            root: classes.textField,
                                                            input: { textAlign: 'left' }
                                                        },
                                                    }}
                                                    InputLabelProps={{
                                                        classes: {
                                                            root: classes.textFieldLabel,
                                                        },
                                                    }}
                                                />
                                            </Grid>

                                            {/* <Grid item xs={12} sm={6}>
                          <TextField

                            id="address_country"
                            name="address_country"
                            label="País"
                            required
                            fullWidth
                            select
                            onChange={this.handleTextField}
                            value={this.state.address_country}
                            InputProps={{
                              classes: {
                                root: classes.textField,
                                input: { textAlign: 'left' }
                              },
                            }}
                            InputLabelProps={{
                              classes: {
                                root: classes.textFieldLabel,
                              },
                            }}
                            SelectProps={{
                              MenuProps: {
                                className: classes.menu,
                              },
                            }}
                          >

                            {this.state.countries_options.map(country => (
                              <MenuItem key={country.id} value={country}>
                                {country.name}
                              </MenuItem>
                            ))}

                          </TextField>


                        </Grid> */}




                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    id="email"
                                                    name="email"
                                                    label="E-Mail"
                                                    type="email"
                                                    fullWidth
                                                    required
                                                    value={this.state.email}
                                                    onChange={this.handleTextField}
                                                    InputProps={{
                                                        classes: {
                                                            root: classes.textField,
                                                            input: { textAlign: 'left' }
                                                        },
                                                    }}
                                                    InputLabelProps={{
                                                        classes: {
                                                            root: classes.textFieldLabel,
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>

                                                <TextField
                                                    id="email_validation"
                                                    name="email_validation"
                                                    label="Confirmar E-Mail"
                                                    type="email"
                                                    fullWidth
                                                    required
                                                    autocomplete="off"
                                                    // value={this.state.email_validation}
                                                    // onChange={this.handleTextField}

                                                    onChange={this.emailValidchange}

                                                    InputProps={{
                                                        classes: {
                                                            root: classes.textField,
                                                            input: { textAlign: 'left' }
                                                        },
                                                    }}
                                                    InputLabelProps={{
                                                        classes: {
                                                            root: classes.textFieldLabel,
                                                        },
                                                    }}
                                                />

                                            </Grid>

                                            <Grid item xs={12} sm={6} >
                                                <TextField
                                                    required
                                                    id="favorite_date"
                                                    name="favorite_date"
                                                    label="Fecha Preferida"
                                                    type="datetime-local"
                                                    fullWidth
                                                    // autoComplete="fname"
                                                    value={this.state.company}
                                                    onChange={this.handleTextField}
                                                    InputProps={{
                                                        classes: {
                                                            root: classes.textField,
                                                            input: { textAlign: 'left' }
                                                        },
                                                    }}
                                                    InputLabelProps={{
                                                        shrink:true,
                                                        classes: {
                                                            root: classes.textFieldLabel,
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} >
                                                <TextField
                                                    required
                                                    id="alternative_date"
                                                    name="alternative_date"
                                                    label="Fecha Alternativa"
                                                    type="datetime-local"
                                                    
                                                    fullWidth
                                                    // autoComplete="fname"
                                                    value={this.state.country}
                                                    onChange={this.handleTextField}
                                                    InputProps={{
                                                        classes: {
                                                            root: classes.textField,
                                                            input: { textAlign: 'left' }
                                                        },
                                                    }}
                                                    
                                                    InputLabelProps={{
                                                        shrink:true,
                                                        classes: {
                                                            root: classes.textFieldLabel,
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                            <Grid style={{ height: '100%' }} item xs={12} >
                                                <div>
                                                    <TextField
                                                        id="outlined-multiline-flexible"
                                                        label="Sobre sus Necesidades"
                                                        placeholder="Cuentenos sobre sus necesidades para que podamos preparar una demo personalizada"
                                                        multiline
                                                        fullWidth
                                                        rowsMax="8"
                                                        rows={5}
                                                        margin="normal"
                                                        variant="outlined"
                                                        InputProps={{
                                                            classes: {
                                                                root: classes.textField,
                                                                input: { textAlign: 'left' }
                                                            },
                                                        }}
                                                        InputLabelProps={{
                                                            classes: {
                                                                root: classes.textFieldLabel,
                                                            },
                                                        }}
                                                    />
                                                </div>
                                            </Grid>
                                        </Grid>
                                        {/* <Grid className={classes.commonMargin} direction='row' alignItems='flex-end' justify='space-between' container > */}
                                        <Grid className={classes.commonMargin} container justify='space-between' spacing="8">
                                            <Grid item xs={12} sm={4}>
                                                {/* <Button onClick={this.goBack} variant="contained" className={classes.buttonBack}>
                                                    <i style={{ marginRight: "8px" }} className="fa fa-1x fa-chevron-left"></i>
                                                    Volver
                          </Button> */}
                                            </Grid>

                                            <Grid item xs={12} sm={4}>

                                                <Button type="submit" variant="contained" className={classes.button}>
                                                    Solicitar Demo
                    <i style={{ marginLeft: "8px" }} className="far fa-envelope"></i>
                                                </Button>

                                            </Grid>
                                        </Grid>



















                                    </form>
                                    {/* </div> */}
                                </Paper>
                            </Grid>






                        </Grid>





                    </main>
                </CSSTransition>

            </React.Fragment>


        );
    }
}


DemoRequest.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(DemoRequest));